// extracted by mini-css-extract-plugin
export default {"container":"CloseButton_container__+r4Op","darkTheme":"CloseButton_darkTheme__7Lu3a","lightTheme":"CloseButton_lightTheme__IpZgC"};